export default __webpack_public_path__ + "static/media/Roboto-Medium.fc0337b9.woff2";